<template>
  <pu-modal
    ref="puModal"
    class="cs-map-modal"
    :use-portal="true"
    :modal-class="'cs-map-modal'"
    data-test="campsite-details-map"
    modal-hash="map"
    @change-show-modal-state="modalLoaded = $event"
  >
    <template #modal-trigger>
      <slot name="modal-trigger">
        <div>
          <div class="map-link" data-test="campsite-details-map-link">
            <img
              src="@/assets/images/map-pin-mini.svg"
              width="15"
              height="18"
              alt=""
            />
            <translate>Map</translate>
          </div>
        </div>
      </slot>
    </template>
    <template #footer>
      <slot name="card" />
    </template>
    <section class="map-holder" data-test="campsite-details-map-modal-content">
      <lazy-campsites-markers-only-map
        v-if="modalLoaded"
        :campsites="[mapCampsite]"
        :is-campsite-details="true"
        :centre="mapCampsite.point"
      />
    </section>
  </pu-modal>
</template>

<script lang="ts">
import type PuModal from '~/components/ui/PuModal.vue'
import {
  Component,
  Prop,
  Ref,
  Vue,
  toNative,
} from '~/utility/pu-class-decorator'
import type { CampsiteDetails } from '../../campsite-details/types'
import { MapCampsite } from '../../maps/domain/MapsCampsite'
import { campsiteToMapCampsite } from '../maps'

@Component
class CampsiteMapModal extends Vue {
  @Prop({ required: true })
  campsite: CampsiteDetails

  @Ref()
  private readonly puModal: PuModal

  modalLoaded = false

  closeModal() {
    this.puModal.closeModal()
  }

  get mapCampsite(): MapCampsite {
    return campsiteToMapCampsite(this.campsite)
  }
}

export default toNative(CampsiteMapModal)
</script>
<style>
.cs-map-modal .modal-header {
  z-index: 999;
}

.cs-map-modal {
  flex-shrink: 0;
}

.cs-map-modal.modal-container {
  height: calc(100% - 6vw);
}

.cs-map-modal .modal-header .close-button {
  background: white;
  box-shadow: inset 0 0 3px #555;
}

.cs-map-modal .modal-footer .infowindow {
  background: white;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.25);
}

.cs-map-modal .card-info h4 {
  font-size: 1em !important;
}

.cs-map-modal .card-info .location {
  font-size: 0.8em;
}

.modal-container.cs-map-modal.desktop {
  max-width: none;
}
</style>
<style scoped>
.map-link {
  align-items: center;
  background: #f2f2f2;
  border-radius: 1em 0 0 1em;
  color: var(--colour-text-default);
  display: flex;
  font-size: var(--body);
  margin: 0 -1.6em 0 0.7em;
  padding: 0.4em 1.35em 0.4em 0.55em;
  user-select: none;
}

.map-link img {
  width: 1em;
  height: 1.2em;
  margin-right: 0.2em;
}

.map-holder {
  display: block;
  width: 94vw;
  height: 100%;
}
</style>
